import {$en, I18nString} from "@/i18n/i18nString";
import {titleToHash} from "@/utils/publications";
import publications from "@/store/publications";

export interface News {
    title: I18nString
    date: string // 必须是YYYY-MM-DD的格式，其中DD可选
    md?: string | (() => Promise<string | typeof import("*.md")>) // 通常是通过异步require引入一个markdown文件。（利用了markdown-loader包，实际上require markdown文件得到的就是一段html字符串，因此理论上，这里填写markdown字符串也是没有任何问题的）
    href?: string
    abstract?: I18nString
    img?: string
    color?: string // 可以不必手工填写，会随机数值
}
/* Template:
{
    title: {
        en: '',
        zh: ''
    },
    date: '2025-11'
},*/
function state() {
    const news: News[] = [
        {
            title: {
                en: 'Associate Professor Gao Yue was invited to serve as an Associate Editor (AE) of the prestigious international journal IEEE Transactions on Pattern Analysis and Machine Intelligence (IEEE TPAMI), a top-tier journal in Artificial Intelligence with an impact factor of 18.6, ranked CCF Class A in China.',
                zh: '高跃副教授受邀担任国际权威学术期刊IEEE Transactions on Pattern Analysis and Machine Intelligence (IEEE TPAMI) 编委。IEEE TPAMI是人工智能领域的国际顶级期刊，影响因子为18.6，在中国计算机学会（CCF）期刊会议推荐列表中为A类'
            },
            date: '2025-11'
        },
        {
            title: {
                en: 'Dr. Feng Yifan, Postdoctoral Fellow, was selected for the 2025 CSIG Outstanding Doctoral Dissertation Incentive Program of the China Society of Image and Graphics (CSIG)',
                zh: '丰一帆博士后入选2025年度中国图象图形学学会博士学位论文激励计划'
            },
            date: '2025-11'
        },
        {
            title: {
                en: 'Dr. Bao Wei, Postdoctoral Fellow, was awarded the fellowship from the China Postdoctoral Science Foundation',
                zh: '鲍威博士后获批中国博士后科学基金第78批面上项目'
            },
            date: '2025-11'
        },
        {
            title: {
                en: 'Two papers (Cog-RAG: Cognitive-Inspired Dual-Hypergraph with Theme Alignment Retrieval-Augmented Generation, Role Hypergraph Contrastive Learning for Multivariate Time-Series Analysis) have been accepted by AAAI 2026',
                zh: '两篇论文(Cog-RAG: Cognitive-Inspired Dual-Hypergraph with Theme Alignment Retrieval-Augmented Generation，Role Hypergraph Contrastive Learning for Multivariate Time-Series Analysis)被AAAI 2026录用'
            },
            date: '2025-11'
        },
        {
            title: {
                en: 'One paper (Graph Quality Matters on Revealing the Semantics Behind the Data in Physica World) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Graph Quality Matters on Revealing the Semantics Behind the Data in Physica World)被IEEE TPAMI录用'
            },
            date: '2025-10',
        },
        {
            title: {
                en: 'One paper (Reinterpreting Hypergraph Kernels: Insights Through Homomorphism Analysis) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Reinterpreting Hypergraph Kernels: Insights Through Homomorphism Analysis)被IEEE TPAMI录用'
            },
            date: '2025-09',
        },
        {
            title: {
                en: 'Dr. Li Siqi, Postdoctoral Fellow,was awarded theYoung Scientists Fund of the National Natural Science Foundation of China (Category C)',
                zh: '李思奇博士后获批国家自然科学基金青年科学基金项目（C类）'
            },
            date: '2025-08'
        },
        {
            title: {
                en: 'One paper (Hypergraph-Based High-Order Correlation Analysis for Large-Scale Long-Tailed Data Red Classification) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hypergraph-Based High-Order Correlation Analysis for Large-Scale Long-Tailed Data red Classification)被IEEE TPAMI录用'
            },
            date: '2025-08',
        },
        {
            title: {
                en: 'One paper (Self-Supervised Hypergraph Training Framework via Structure-Aware Learning) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Self-Supervised Hypergraph Training Framework via Structure-Aware Learning)被IEEE TPAMI录用'
            },
            date: '2025-07',
        },
        {
            title: {
                zh: '李思奇博士后获批中国博士后科学基金第77批面上项目',
                en: 'Dr. Li Siqi, Postdoctoral Fellow, was awarded the fellowship from the China Postdoctoral Science Foundation'
            },
            date: '2025-07',
        },
        {
            title: {
                zh: '丰一帆博士入选清华大学学术新秀（全校仅十人）',
                en: 'Dr. Feng Yifan was selected as one of Tsinghua University Academic Rising Stars (Top 10 university-wide)'
            },
            date: '2025-06',
        },
        {
            title: {
                en: 'One paper (Kernelized Hypergraph Neural Networks) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Kernelized Hypergraph Neural Networks)被IEEE TPAMI录用'
            },
            date: '2025-06',
        },
        {
            title: {
                en: 'We are pleased to announce the 7th Workshop on GRaphs in biomedicAl Image anaLysis (GRAIL 2025), which will be held in conjunction with MICCAI 2025 from 23 to 27 September 2025 in Daejeon, Republic of Korea.',
                zh: '我们将在MICCAI2025（2025年9月23日至27日，韩国大田）举办第七届“生物医学图像分析中的图学习”专题论坛 (GRAIL 2025), 欢迎大家参加'
            },
            date: '2025-06',
            href: "/activity/MICCAI%202025%20Workshop%20Track:%20Hypergraph%20Computation%20for%20Medical%20Image%20Analysis"
        },
        {
            title: {
                en: 'Three papers have been accepted by MICCAI 2025',
                zh: '三篇论文被 MICCAI 2025 录用'
            },
            date: '2025-06'
        },
        {
            title: {
                en: 'One paper (HGTL: A hypergraph transfer learning framework for survival prediction of ccRCC) has been accepted by MedIA',
                zh: '一篇论文(HGTL: A hypergraph transfer learning framework for survival prediction of ccRCC)被 MedIA 录用'
            },
            date: '2025-06'
        },
        {
            title: {
                en: 'One paper (Multimodal Hypergraph Guide Learning for Non-Invasive ccRCC Survival Prediction) has been provisionally accepted by MICCAI 2025',
                zh: '一篇论文(Multimodal Hypergraph Guide Learning for Non-Invasive ccRCC Survival Prediction)被 MICCAI 2025 提前录用'
            },
            date: '2025-05'
        },
        {
            title: {
                en: 'One paper (Inter-intra hypergraph computation for survival prediction on whole slide images) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Inter-intra hypergraph computation for survival prediction on whole slide images)被IEEE TPAMI录用'
            },
            date: '2025-03'
        },
        {
            title: {
                en: 'One paper (Hypergraph Foundation Model for Brain Disease Diagnosis) has been accepted by IEEE TNNLS',
                zh: '一篇论文(Hypergraph Foundation Model for Brain Disease Diagnosis)被IEEE TNNLS录用'
            },
            date: '2025-03'
        },
        {
            title: {
                en: 'One paper (Event-enhanced synthetic aperture imaging) has been accepted by Science China Information Sciences',
                zh: '一篇论文(Event-enhanced synthetic aperture imaging)被Science China Information Sciences录用'
            },
            date: '2025-03'
        },
        {
            title: {
                en: 'We are pleased to announce the 3rd Workshop on Graph Learning in Medical Image Analysis (GraphMedIA 2025), which will be held in conjunction with MICCAI 2025 from 23 to 27 September 2025 in Daejeon, Republic of Korea.',
                zh: '我们将在MICCAI2025（2025年9月23日至27日，韩国大田）举办第三届“医学图像分析中的图学习”专题讲习班 (GraphMedIA), 欢迎大家参加'
            },
            date: '2025-02',
            href: "/activity/MICCAI%202025%20Tutorial:%203rd%20Graph%20Learning%20in%20Medical%20Image%20Analysis%20(GraphMedIA)"
        },
        {
            title: {
                en: 'One paper (Image Matting and 3D Reconstruction in One Loop) has been accepted by IJCV',
                zh: '一篇论文(Image Matting and 3D Reconstruction in One Loop)被IJCV录用'
            },
            date: '2025-02'
        },
        {
            title: {
                en: 'One paper (Channel pruning on frequency response) has been accepted by Science China Information Sciences',
                zh: '一篇论文(Channel pruning on frequency response)被Science China Information Sciences录用'
            },
            date: '2025-01'
        },
        {
            title: {
                en: 'One paper (Cross-Modal 3D Shape Retrieval via Heterogeneous Dynamic Graph Representation) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Cross-Modal 3D Shape Retrieval via Heterogeneous Dynamic Graph Representation)被IEEE TPAMI录用'
            },
            date: '2024-12'
        },
        {
            title: {
                en: 'One paper (Hyper-yolo: When visual object detection meets hypergraph computation) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hyper-yolo: When visual object detection meets hypergraph computation)被IEEE TPAMI录用'
            },
            date: '2024-12'
        },
        {
            title: {
                en: 'One paper (Hyper-3dg: Text-to-3d gaussian generation via hypergraph) has been accepted by IJCV',
                zh: '一篇论文(Hyper-3dg: Text-to-3d gaussian generation via hypergraph)被IJCV录用'
            },
            date: '2024-12'
        },
        {
            title: {
                zh: '韩向敏博士后获批中国博士后科学基金第76批面上项目',
                en: 'Dr. Xiangmin Han, Postdoctoral Fellow, was awarded the fellowship from the China Postdoctoral Science Foundation',
            },
            date: '2024-11',
        },
        {
            title: {
                en: 'Pattern Recognition Special Issue Call for Papers：Graph Foundation Model for Medical Image Analysis',
                zh: '我们主持了Pattern Recognition期刊的特刊：Graph Foundation Model for Medical Image Analysis, 欢迎大家投稿'
            },
            date: '2024-10'
        },
        {
            title: {
                en: 'Three papers (Hypergraph-Based Fuzzy Assembled Representation for Open-Set 3D Object Retrieval, Multi-scale Consistency for Robust 3D Registration via Hierarchical Sinkhorn Tree, Semi-Open 3D Object Retrieval via Hypergraph-Based Hierarchical Equilibrium Representation) has been accepted by NeurIPS 2024',
                zh: '三篇论文 (Hypergraph-Based Fuzzy Assembled Representation for Open-Set 3D Object Retrieval, Multi-scale Consistency for Robust 3D Registration via Hierarchical Sinkhorn Tree, Semi-Open 3D Object Retrieval via Hypergraph-Based Hierarchical Equilibrium Representation) 被NeurIPS 2024录用'
            },
            date: '2024-09'
        },
        {
            title: {
                en: 'Dr. Feng Yifan was awarded the Youth Student Basic Research Project from the National Natural Science Foundation of Chinas (Doctoral Candidates)',
                zh: '丰一帆博士获批国家自然科学基金青年学生基础研究项目（博士研究生）'
            },
            date: '2024-09'
        },
        {
            title: {
                en: 'Dr. Han Xiangmin, Postdoctoral Fellow, was awarded the Young Scientists Fund of the National Natural Science Foundation of China (Category C).',
                zh: '韩向敏博士后获批国家自然科学基金青年科学基金项目（C类）'
            },
            date: '2024-08'
        },
        {
            title: {
                en: 'One paper (Inter-Intra high-order Brain Network for ASD Diagnosis via Functional MRIs) has been accepted by MICCAI',
                zh: '一篇论文 (Inter-Intra high-order Brain Network for ASD Diagnosis via Functional MRIs) 被MICCAI 2024录用'
            },
            date: '2024-06'
        },
        {
            title: {
                en: 'One paper (ccRCC Metastasis Prediction via Exploring High-Order Correlations on Multiple WSIs) has been provisionally accepted by MICCAI',
                zh: '一篇论文 (ccRCC Metastasis Prediction via Exploring High-Order Correlations on Multiple WSIs) 被MICCAI 2024提前录用'
            },
            date: '2024-05'
        },
        {
            title: {
                en: 'One paper (Hypergraph Computation) has been accepted by Engineering',
                zh: '一篇论文(Hypergraph Computation)被Engineering录用'
            },
            date: '2024-04'
        },
        {
            title: {
                en: 'One paper (Hypergraph-based Multi-View ActionRecognition using Event Cameras) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hypergraph-based Multi-View ActionRecognition using Event Cameras)被IEEE TPAMI录用'
            },
            date: '2024-03'
        },
        {
            title: {
                en: 'One paper (Generative Variational-Contrastive Learning for Self-supervised Point Cloud Representation) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Generative Variational-Contrastive Learning for Self-supervised Point Cloud Representation)被IEEE TPAMI录用'
            },
            date: '2024-03'
        },
        {
            title: {
                en: 'Two papers (ColorPCR: Color Point Cloud Registration with Multi-Stage Geometric-Color Fusion, 3D Feature Tracking via Event Camera) have been accepted by CVPR 2024',
                zh: '两篇论文(ColorPCR: Color Point Cloud Registration with Multi-Stage Geometric-Color Fusion，3D Feature Tracking via Event Camera)被CVPR 2024录用'
            },
            date: '2024-03'
        },
        {
            title: {
                en: 'Two papers(Hypergraph Dynamic System, LightHGNN: Distilling Hypergraph Neural Networks into MLPs for 100x Faster Inference) have been accepted by ICLR 2024',
                zh: '两篇论文(Hypergraph Dynamic System，LightHGNN: Distilling Hypergraph Neural Networks into MLPs for 100x Faster Inference)被ICLR2024录用'
            },
            date: '2024-01'
        },
        {
            title: {
                en: 'One paper (Hypergraph Isomorphism Computation) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hypergraph Isomorphism Computation)被IEEE TPAMI录用'
            },
            date: '2023-12'
        },
        {
            title: {
                en: 'One paper (Hypergraph-Based Multi-Modal Representation for Open-Set 3D Object Retrieval) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hypergraph-Based Multi-Modal Representation for Open-Set 3D Object Retrieval)被IEEE TPAMI录用'
            },
            date: '2023-11'
        },
        {
            title: {
                en: 'One paper (Efficient Hypergraph Neural Network on Million-level Data) has been accepted by SCIENTIA SINICA Informationis',
                zh: '一篇论文(面向大规模数据的高效超图神经网络)被中国科学: 信息科学录用'
            },
            date: '2023-10'
        },
        {
            title: {
                en: 'One paper (Hierarchical Set-to-set Representation for 3D Cross-modal Retrieval) has been accepted by IEEE TNNLS',
                zh: '一篇论文(Hierarchical Set-to-set Representation for 3D Cross-modal Retrieval)被IEEE TNNLS录用'
            },
            date: '2023-10'
        },
        {
            title: {
                en: 'One paper (Penalized Flow Hypergraph Local Clustering) has been accepted by IEEE TKDE',
                zh: '一篇论文(Penalized Flow Hypergraph Local Clustering)被IEEE TKDE录用'
            },
            date: '2023-09'
        },
        {
            title: {
                en: 'One paper (Hunter: Exploring High-Order Consistency for Point Cloud Registration with Severe Outliers) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hunter: Exploring High-Order Consistency for Point Cloud Registration with Severe Outliers)被IEEE TPAMI录用'
            },
            date: '2023-08'
        },
        {
            title: {
                en: 'One paper (Action Recognition and Benchmark using Event Cameras) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Action Recognition and Benchmark using Event Cameras)被IEEE TPAMI录用'
            },
            date: '2023-07'
        },
        {
            title: {
                en: `Dr. Gao Yue was selected as one of DeepTech's "2022 China Intelligent Computing Technology Innovators"`,
                zh: '实验室高跃副教授入选DeepTech“2022年中国智能计算科技创新人物”'
            },
            date: '2023-04'
        },
        {
            title: {
                en: 'The project of "Complex Association Computation of Visual Information" won the First Prize of Natural Science in Science and Technology Award of Chinese Institute of Electronics',
                zh: '实验室“视觉信息复杂关联计算”项目获得中国电子学会科学技术奖自然科学一等奖'
            },
            date: '2023-04'
        },
        {
            title: {
                en: 'One paper (High-Order Correlation-Guided Slide-Level Histology Retrieval with Self-Supervised Hashing) has been accepted by IEEE TPAMI',
                zh: '一篇论文(High-Order Correlation-Guided Slide-Level Histology Retrieval with Self-Supervised Hashing)被IEEE TPAMI录用'
            },
            date: '2023-04'
        },
        {
            title: {
                en: 'One paper (SuperFast: 200x Video Frame Interpolation via Event Camera) has been accepted by IEEE TPAMI',
                zh: '一篇论文(SuperFast: 200x Video Frame Interpolation via Event Camera)被IEEE TPAMI录用'
            },
            date: '2022-11'
        },
        {
            title: {
                en: 'One paper (Structure Evolution on Manifold for Graph Learning) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Structure Evolution on Manifold for Graph Learning)被IEEE TPAMI录用'
            },
            date: '2022-11'
        },
        {
            title: {
                en: 'One paper (Skeleton Temporal Hypergraph Neural Networks for Person Re-Identification) has been accepted by IEEE TIP',
                zh: '一篇论文(Skeleton Temporal Hypergraph Neural Networks for Person Re-Identification)被IEEE TIP录用'
            },
            date: '2022-09'
        },
        {
            title: {
                en: 'One paper (Generating Hypergraph-based High-Order Representations of Whole-Slide Histopathological Images for Survival Prediction) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Generating Hypergraph-based High-Order Representations of Whole-Slide Histopathological Images for Survival Prediction)被IEEE TPAMI录用'
            },
            date: '2022-09'
        },
        {
            title: {
                en: 'One paper (Grow and Merge: A Unified Framework for Continuous Categories Discovery) has been accepted by NeurIPS',
                zh: '一篇论文(Grow and Merge: A Unified Framework for Continuous Categories Discovery)被NeurIPS录用'
            },
            date: '2022-07'
        },
        {
            title: {
                en: 'One paper (Hypergraph Learning: Methods and Practices) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Hypergraph Learning: Methods and Practices)被TPAMI录用'
            },
            date: '2022-07'
        },
        {
            title: {
                en: 'One paper (HGNN+: General Hypergraph Neural Networks) has been accepted by IEEE TPAMI',
                zh: '一篇论文(HGNN+: General Hypergraph Neural Networks)被IEEE TPAMI录用'
            },
            date: '2022-05'
        },
        {
            title: {
                en: "Jielong Yan was selected into the 'Future Scholar' Program of Tsinghua University",
                zh: '颜杰龙同学入选清华大学“未来学者”计划'
            },
            date: '2022-04'
        },
        {
            title: {
                en: 'One paper (Graph Learning on Millions of Data in Seconds: Label Propagation Acceleration on Graph using Data Distribution) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Graph Learning on Millions of Data in Seconds: Label Propagation Acceleration on Graph using Data Distribution)被IEEE TPAMI录用'
            },
            date: '2022-03'
        },
        {
            title: {
                en: 'One paper (Rotation-Invariant Point Cloud Representation for 3-D Model Recognition) has been accepted by IEEE TCYB',
                zh: '一篇论文(Rotation-Invariant Point Cloud Representation for 3-D Model Recognition)被IEEE TCYB录用'
            },
            date: '2022-02'
        },
        {
            title: {
                en: 'One paper (STORM: Structure-based Overlap Matching for Partial Point Cloud Registration) has been accepted by IEEE TPAMI',
                zh: '一篇论文(STORM: Structure-based Overlap Matching for Partial Point Cloud Registration)被IEEE TPAMI录用'
            },
            date: '2022-01'
        },
        {
            title: {
                en: 'One paper (Rethinking Supervised Pre-training for Better Downstream Transferring) has been accepted by ICLR 2022',
                zh: '一篇论文(Rethinking Supervised Pre-training for Better Downstream Transferring)被ICLR 2022录用'
            },
            date: '2022-01'
        },
        {
            title: {
                en: 'One paper (Big-Hypergraph Factorization Neural Network for Survival Prediction From Whole Slide Image) has been accepted by IEEE TIP',
                zh: '一篇论文(Big-Hypergraph Factorization Neural Network for Survival Prediction From Whole Slide Image)被IEEE TIP录用'
            },
            date: '2021-12'
        },
        {
            title: {
                en: 'One paper (Learning Representation on Optimized High-Order Manifold for Visual Classification) has been accepted by IEEE TMM',
                zh: '一篇论文(Learning Representation on Optimized High-Order Manifold for Visual Classification)被IEEE TMM录用'
            },
            date: '2021-12'
        },
        {
            title: {
                en: 'Yining Zhao won the 2021 SenseTime Scholarship',
                zh: '赵乙宁同学荣获2021年商汤奖学金'
            },
            date: '2021-11'
        },
        {
            title: {
                en: 'One paper (Exploring Complex and Heterogeneous Correlations on Hypergraph for the Prediction of Drug-Target Interactions) has been accepted by Patterns (Cell Press)',
                zh: '一篇论文(Exploring Complex and Heterogeneous Correlations on Hypergraph for the Prediction of Drug-Target Interactions)被Patterns (Cell Press)录用'
            },
            date: '2021-11'
        },
        {
            title: {
                en: "Shengrui Li was selected into the 'Future Scholar' Program of Tsinghua University",
                zh: '李胜锐同学入选清华大学“未来学者”计划'
            },
            date: '2021-09-14'
        },
        {
            title: {
                en: 'One paper (Visual Information Quantification for Object Recognition and Retrieval) has been accepted by Science Chine',
                zh: '一篇论文(Visual Information Quantification for Object Recognition and Retrieval)被中国科学录用'
            },
            date: '2021-09-05'
        },
        {
            title: {
                en: 'One paper (Survey on Facial Expression Recognition: History, Applications, and Challenges) has been accepted by IEEE TMM',
                zh: '一篇论文(Survey on Facial Expression Recognition: History, Applications, and Challenges)被IEEE TMM录用'
            },
            date: '2021-09-01'
        },
        {
            title: {
                en: 'One paper (Adaptive Hypergraph Auto-Encoder for Relational Data Clustering) has been accepted by IEEE TKDE',
                zh: '一篇论文(Adaptive Hypergraph Auto-Encoder for Relational Data Clustering)被IEEE TKDE录用'
            },
            date: '2021-08-25'
        },
        {
            title: {
                en: 'One paper (Event Stream Super-Resolution via Spatiotemporal Constraint Learning) has been accepted by ICCV 2021',
                zh: '一篇论文(Event Stream Super-Resolution via Spatiotemporal Constraint Learning)被ICCV 2021录用'
            },
            date: '2021-07-23'
        },
        {
            title: {
                en: 'One paper (Recu: Reviving the Dead Weights in Binary Neural Networks) has been accepted by ICCV 2021',
                zh: '一篇论文(Recu: Reviving the Dead Weights in Binary Neural Networks)被ICCV 2021录用'
            },
            date: '2021-07-23'
        },
        {
            title: {
                en: 'Yezhen Cong was selected into the Outstanding Graduate of Tsinghua University and the Outstanding Graduate of Beijing',
                zh: '从业臻等同学入选清华大学优秀毕业生、北京市毕业生'
            },
            date: '2021-06-27'
        },
        {
            title: {
                en: 'The laboratory and Alibaba Dharma Institute jointly won the championship of ActivityNet AVA-Kinetics',
                zh: '实验室与阿里巴巴达摩院联合获得ActivityNet AVA-Kinetics比赛冠军'
            },
            date: '2021-06-19'
        },
        {
            title: {
                en: 'One paper (Heterogeneous Hypergraph Variational Autoencoder for Link Prediction) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Heterogeneous Hypergraph Variational Autoencoder for Link Prediction)被IEEE TPAMI录用'
            },
            date: '2021-06-09'
        },
        {
            title: {
                en: 'Yue Gao was selected into 2020 Elsevier Highly Cited Chinese Researchers',
                zh: '高跃副教授入选2020年爱思唯尔中国高被引学者榜单'
            },
            date: '2021-05-10'
        },
        {
            title: {
                en: 'One paper (DAN: Deep-Attention Network for 3D Shape Recognition) has been accepted by IEEE TIP',
                zh: '一篇论文(DAN: Deep-Attention Network for 3D Shape Recognition)被IEEE TIP录用'
            },
            date: '2021-05-10'
        },
        {
            title: {
                en: "Yue Gao was selected into the World's Most Influential AI Scholar (AI 2000) In 2021",
                zh: '高跃副教授入选2021年全球最具影响力的2000名AI学者榜单'
            },
            date: '2021-04-21'
        },
        {
            title: {
                en: 'One paper (3DIoUMatch: Leveraging iou prediction for semi-supervised 3d object detection) has been accepted by CVPR 2021',
                zh: '一篇论文(3DIoUMatch: Leveraging iou prediction for semi-supervised 3d object detection)被CVPR 2021录用'
            },
            date: '2021-03-01'
        },
        {
            title: {
                en: 'One paper (View-Guided Point Cloud Completion) has been accepted by CVPR 2021',
                zh: '一篇论文(View-Guided Point Cloud Completion)被CVPR 2021录用'
            },
            date: '2021-03-01'
        },
        {
            title: {
                en: 'One paper (View-aware geometry-structure joint learning for single-view 3D shape reconstruction) has been accepted by IEEE TPAMI',
                zh: '一篇论文(View-aware geometry-structure joint learning for single-view 3D shape reconstruction)被IEEE TPAMI录用'
            },
            date: '2021-02-08'
        },
        {
            title: {
                en: 'One paper (Few-shot Learning by a Cascaded Framework with Shape-constrained Pseudo Label Assessment for Whole Heart Segmentation) has been accepted by IEEE TMI',
                zh: '一篇论文(Few-shot Learning by a Cascaded Framework with Shape-constrained Pseudo Label Assessment for Whole Heart Segmentation)被IEEE TMI录用'
            },
            date: '2021-01-16'
        },
        {
            title: {
                en: 'Yue Gao was selected into the Web of Science Highly Cited Researchers of 2020',
                zh: '高跃副教授入选2020年Web of Science高被引学者榜单'
            },
            date: '2021-01-10'
        },
        {
            title: {
                en: 'One paper (Special Issue on Intelligent Analysis of COVID-19 Imaging Data)被 has been accepted by Medical Image Analysis',
                zh: '一篇论文(Special Issue on Intelligent Analysis of COVID-19 Imaging Data)被Medical Image Analysis录用'
            },
            date: '2020-11-14'
        },
        {
            title: {
                en: 'One paper (Deep multi-view enhancement hashing for image retrieval) has been accepted by IEEE TPAMI',
                zh: '一篇论文(Deep multi-view enhancement hashing for image retrieval)被IEEE TPAMI录用'
            },
            date: '2020-11-03'
        },
        {
            title: {
                en: 'Qing Xia was selected into the Beijing Science and Technology Star Program of 2020',
                zh: '实验室夏清博士后入选2020年北京市科技新星计划'
            },
            date: '2020-08-12'
        },
        {
            title: {
                en: 'Yue Gao won the Annual Teaching Excellence Award of Tsinghua University',
                zh: '高跃副教授获得清华大学年度教学优秀奖'
            },
            date: '2020-07-15'
        },
        {
            title: {
                en: "Yue Gao was selected into the World's Most Influential AI Scholar (AI 2000) In 2020",
                zh: '高跃副教授入选2020年全球最具影响力的2000名AI学者榜单'
            },
            date: '2020-01-13'
        },
        {
            title: {
                en: 'The team won the First Prize of Fujian Science and Technology Progress ',
                zh: '实验室团队荣获福建省科学技术进步一等奖'
            },
            date: '2019-12-30'
        },
        {
            title: {
                en: 'Yue Gao was selected into the Web of Science Highly Cited Researchers of 2019',
                zh: '高跃副教授入选2019年Web of Science高被引学者榜单'
            },
            date: '2019-12-20'
        },
        {
            title: {
                en: 'Yezhen Cong won the 2019 SenseTime Scholarship',
                zh: '从业臻同学荣获2019年商汤奖学金'
            },
            date: '2019-12-02'
        },
        {
            title: {
                en: 'Zizhao Zhang won the Microsoft Research Asia Fellowship Program',
                zh: '张子昭同学荣获微软学者奖学金'
            },
            date: '2019-11-08'
        },
        {
            title: {
                en: "Yutong Feng was selected into the 'Future Scholar' Program of Tsinghua University",
                zh: '冯玉彤同学入选清华大学“未来学者”计划'
            },
            date: '2019-06-03'
        },
        {
            title: {
                en: 'Yutong Feng won the 2018 SenseTime Scholarship',
                zh: '冯玉彤同学荣获2018年商汤奖学金'
            },
            date: '2018-12-02'
        },
        {
            title: {
                en: 'Yue Gao was selected into the Web of Science Highly Cited Researchers of 2018',
                zh: '高跃副教授入选2018年Web of Science高被引学者榜单'
            },
            date: '2018-11-27'
        },
        {
            title: {
                en: 'Zizhao Zhang et. al won the Best Student Paper of PCM 2018',
                zh: '张子昭等同学论文获得PCM 2018最佳学生论文奖'
            },
            date: '2018-09-21'
        },
        {
            title: {
                en: 'The team won the First Prize of the ActivityNet Space time Behavior Positioning Competition',
                zh: '实验室团队获得ActivityNet时空行为定位比赛冠军'
            },
            date: '2018-06-28'
        }
    ]
    // news.forEach(v => v.color = v.color ?? colors[md5(v.title, { asBytes: true }).pop() as number % 12])
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const publications_hashes = publications.map(v=>titleToHash(v.title!))
    for (const v of news) {
        const title = typeof v.title === "string"?v.title:v.title.zh
        if (title.indexOf("论文") >= 0){
            v.color = v.color ?? "blue";
            const r = /(?:一篇论文|one paper)\s*[(（](.*?)[)）]/i.exec(title)
            if (r) {
                const hash = titleToHash(r[1])
                if (publications_hashes.includes(hash)) v.href = `/publications#${hash}`
            }
        } else {
            v.color = v.color ?? "red"
        }
    }
    return news
}

export default state()
